import { Controller } from "@hotwired/stimulus"

import { apiUrl, putByAxios } from "../helpers/axios.js"

import Sortable from 'sortablejs'

export default class extends Controller {
  static targets = ['table', 'block', 'addhere', 'order', 'fields', 'tbody', 'template', 'add']

  connect() {
    if (this.hasAddTarget) {
      this.updateAddButtonVisibility(this.addTarget)
    }
    if (this.tableTargets.length > 0) {
      this.tableTargets.forEach((el) => {
        this.sortmount(el, 'table')
        document.addEventListener('turbolinks:before-cache', () => {
          this.sortunmount(el)
        }, {once: true})
      })
    }

    if (this.fieldsTargets.length > 0) {
      this.fieldsTargets.forEach((el) => {
        this.sortmount(el, 'fields')
        document.addEventListener('turbolinks:before-cache', () => {
          this.sortunmount(el)
        }, {once: true})
      })
    }

    if (this.blockTargets.length > 0) {
      this.blockTargets.forEach((el) => {
        this.sortmount(el, 'block')
        document.addEventListener('turbolinks:before-cache', () => {
          this.sortunmount(el)
        }, {once: true})
      })
    }
  }

  sortmount(theSortable, target) {
    if (target == 'table') {
      window.sortable = Sortable.create(theSortable, {
        handle: '.sortable-handle',
        draggable: '.sortable-item',
        group: 'nested',
        direction: 'vertical',
        fallbackOnBody: true,
        animation: 150,
        swapThreshold: 0.65,
        onEnd: (evt) => {
          this.updateTbodyOrder()
        }
      })
    } else if (target == 'fields') {
      window.sortable = Sortable.create(theSortable, {
        handle: '.sortable-handle',
        draggable: '.sortable-item',
        group: 'nested',
        direction: 'vertical',
        fallbackOnBody: true,
        animation: 150,
        swapThreshold: 0.65,
        onEnd: (event) => {
          this.updateFormFieldsOrder()
        }
      })
    } else if (target == 'block') {
      window.sortable = Sortable.create(theSortable, {
        handle: '.sortable-handle',
        draggable: '.sortable-item',
        group: 'shared',
        direction: 'vertical',
        sort: false,
        fallbackOnBody: true,
        animation: 150,
        swapThreshold: 0.65,
        onEnd: (e) => {
          this.updateInBlockOrder()
        },
        // onChange: function(e) {
        //   // $(e.item).closest('tbody').parent('table').addClass('on-block-drop')
        //   // e.newIndex // most likely why this event is used is to get the dragging element's current index
        // }
      })
    }

  }

  updateFormFieldsOrder() {
    if (this.orderTargets.length > 0) {
      let index = 0
      this.orderTargets.forEach((el, i) => {
        if (!$(el).is(":hidden")) {
          index += 1
          el.value = index
        }
      })
    }
  }

  updateElOrder(el, order) {
    if (el.getAttribute('data-order') != order) {
      this.remoteUpdate(el, order)
      el.querySelector('.sortable-order').innerHTML = order
      el.setAttribute('data-order', order)
    }
  }

  updateTbodyOrder() {
    if (this.tbodyTargets.length > 0) {
      this.tbodyTargets.forEach((el, index) => {
        this.updateElOrder(el, index+1)
      })
    }
  }

  updateInBlockOrder() {
    if (this.blockTargets.length > 0) {
      this.blockTargets.forEach((el) => {
        let block_order = el.getAttribute('data-order')
        el.querySelectorAll('.sortable-item').forEach((el) => {
          this.updateElOrder(el, block_order)
        })
      })
    }
  }

  updateTrOrder(tbody) {
    tbody.querySelectorAll('.movable-item').forEach((el, index) => {
      this.updateElOrder(el, index+1)
    })
  }


  move_up(event) {
    event.preventDefault()
    const current = $(event.target).closest('.movable-item')
    const prev = current.prevAll('.movable-item').first()
    
    if (this.blockTargets.length > 0) {
      if (current.parent().children().length <= 2) { return }
      let next_table = current.parent().prev()
      if (next_table.length == 0) { return }
      let el = current.detach()
      next_table.append(el)
      this.updateElOrder(current[0], next_table.data('order'))
      return
    }

    if (prev.hasClass('movable-item')) {
      if (this.fieldsTargets.length > 0) {
        prev.before(current)
        this.updateFormFieldsOrder()
      } else if (current.prop('tagName') == 'TBODY') {
        prev.before(current)
        this.updateTbodyOrder()
      } else if (current.prop('tagName') == 'TR') {
        prev.before(current)
        this.updateTrOrder(current[0].parentNode)
      }
    }
  }

  move_down(event) {
    event.preventDefault()
    const current = $(event.target).closest('.movable-item')
    const next = current.nextAll('.movable-item').first()
    
    if (this.blockTargets.length > 0) {
      if (current.parent().children().length <= 2) { return }
      let next_table = current.parent().next()
      if (next_table.length == 0) { return }
      let el = current.detach()
      next_table.append(el)
      this.updateElOrder(current[0], next_table.data('order'))
      return
    }

    if (next.hasClass('movable-item')) {
      if (this.fieldsTargets.length > 0) {
        next.after(current)
        this.updateFormFieldsOrder()
      } else if (current.prop('tagName') == 'TBODY') {
        next.after(current)
        this.updateTbodyOrder()
      } else if (current.prop('tagName') == 'TR') {
        next.after(current)
        this.updateTrOrder(current[0].parentNode)
      }
    }
  }

  add_association(event) {
    event.preventDefault()
    let content = this.templateTarget.innerHTML.replace(/TEMPLATE_RECORD/g, new Date().valueOf())
    this.addhereTarget.insertAdjacentHTML('beforebegin', content)
    this.updateFormFieldsOrder()
    this.updateAddButtonVisibility(this.addTarget)
  }

  remove_association(event) {
    event.preventDefault()
    let item = event.target.closest(".nested-fields")
    item.querySelector("input[name*='_destroy']").value = 1
    item.style.display = 'none'
    this.updateFormFieldsOrder()
    this.updateAddButtonVisibility(event.target)
  }

  updateAddButtonVisibility(target) {
    if (!this.addTarget.dataset.maxNestedFields) { return }
    let currentCount = $(target).closest('form').find('#match-slots .nested-fields:visible').length
    let maxCount = parseInt(this.addTarget.dataset.maxNestedFields)
    if (currentCount >= maxCount) {
      $(this.addTarget).hide()
    } else {
      $(this.addTarget).show()
    }
  }

  remoteUpdate(el, order) {
    const data = { [el.getAttribute('data-record')]: { orde: order } }
    putByAxios(require('axios'), `${apiUrl}/${el.getAttribute('data-endpoint')}/${el.getAttribute('data-id')}`, data)
  }

  gorder(event) {
    event.preventDefault()
    // console.log(event.currentTarget.dataset.default)
    if (!event.currentTarget.dataset.default) {
      return
    }

    let defaultOrder = event.currentTarget.dataset.default.split(',')

    window.sortable.sort(defaultOrder, true)
    this.updateFormFieldsOrder()
    
    $(document).Toasts('create', {
      autohide: true,
      position: 'bottomLeft',
      delay: 3000,
      title: event.currentTarget.dataset.title,
      body: event.currentTarget.dataset.message,
      class: 'bg-success'
    })

  }

  sortunmount(theSortable) {

  }

  disconnect() {

  }

}
